export const lightTheme = {
  colors: {
    accent: '#FF8356',
    backgroundColor: '#FEF9F9',
    backgroundModal: '#ffffff',
    inputText: '#888888',
    inputBackground: '#ffffff',
    inputOutline: 'none',
    pagginationOutline: 'none',
    textColor: '#111111',
    link: '#54ADFF',
    grey: '#888888',
    titleColor: '#111111',
    yellow: '#FFC107',
    green: '#00C3AD',
    red: '#F43F5E',
    lightBlue: '#CCE4FB',
    gradient: 'linear-gradient(290.46deg, #419EF1 0%, #9BD0FF 107.89%)',
    buttonText: '#FEF9F9',
    notificationColorTheme: 'ligth',
    promo: '#c154c1',
    navActive: '#FFC107',
  },
  logo: {
    text: '#303030',
    paw: '#ffc107',
  },
  shadows: {
    default: '3px 8px 14px rgba(136, 198, 253, 0.19)',
    hover: '7px 13px 14px rgba(116, 177, 232, 0.24)',
    promo: '3px 8px 19px rgba(193, 84, 193, 0.8)',
  },
  fonts: {
    main: 'Manrope, san-serif',
    placeholders: 'Inter, san-serif',
  },
  fontSizes: {
    xs: '12px',
    search: '14px',
    s: '16px',
    m: '20px',
    l: '24px',
    xl: '28px',
    title: '48px',
    heroTitle: '68px',
  },
  fontWeiths: {
    normal: '400',
    semi: '500',
    semiBold: '600',
    bold: '700',
  },
  radius: {
    normal: '40px',
    small: '16px',
    round: '50%',
  },
  mediaPoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1280px',
  },
  media: {
    phone: 'screen and (min-width: 480px)',
    tab: 'screen and (min-width: 768px)',
    desk: 'screen and (min-width: 1280px)',
  },
};

export const darkTheme = {
  colors: {
    accent: '#FF8356',
    backgroundColor: '#121212',
    backgroundModal: '#181C25',
    inputText: 'rgb(254, 220, 153)',
    inputBackground: 'transparent',
    inputOutline: '1px solid rgb(254, 220, 153)',
    pagginationOutline: '1px solid #54ADFF',
    textColor: '#FFC107',
    link: '#54ADFF',
    grey: '#CCCCCC',
    titleColor: '#FFC107',
    yellow: '#FEDC99',
    green: '#00C3AD',
    red: '#FF576D',
    lightBlue: '#0A141F',
    gradient:
      'linear-gradient(290.46deg, rgb(5 101 186) 0%, rgb(65, 158, 241) 107.89%)',
    buttonText: '#FEF9F9',
    notificationColorTheme: 'dark',
    promo: '#54ADFF',
    navActive: '#54ADFF',
  },
  logo: {
    text: '#54ADFF',
    paw: '#ffc107',
  },
  shadows: {
    default: '3px 8px 14px rgba(136, 198, 253, 0.19)',
    hover: '7px 13px 14px rgba(116, 177, 232, 0.24)',
    promo: '3px 8px 19px rgba(244, 196, 48, 0.8)',
  },
  fonts: {
    main: 'Manrope, san-serif',
    placeholders: 'Inter, san-serif',
  },
  fontSizes: {
    xs: '12px',
    search: '14px',
    s: '16px',
    m: '20px',
    l: '24px',
    xl: '28px',
    title: '48px',
    heroTitle: '68px',
  },
  fontWeiths: {
    normal: '400',
    semi: '500',
    semiBold: '600',
    bold: '700',
  },
  radius: {
    normal: '40px',
    small: '16px',
    round: '50%',
  },
  mediaPoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1280px',
  },
  media: {
    phone: 'screen and (min-width: 480px)',
    tab: 'screen and (min-width: 768px)',
    desk: 'screen and (min-width: 1280px)',
  },
};
